import { render, staticRenderFns } from "./defaultInfiniteScroll.vue?vue&type=template&id=56cd5d3f&scoped=true"
import script from "./defaultInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./defaultInfiniteScroll.vue?vue&type=script&lang=js"
import style0 from "./defaultInfiniteScroll.vue?vue&type=style&index=0&id=56cd5d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd5d3f",
  null
  
)

export default component.exports